<template>
  <v-client-table
    :data="items"
    :columns="columns"
    :options="options"
    ref="tableListeFacesDemandeSelected">
    <template #date="{ row }">
      {{ formatDate(row.dateRelance) }}
    </template>
    <template #etat="{ row }">
      {{ $t(getEtat(row.etat)) }}
    </template>
    <template #numFacture="{ row }">
      {{ getCodesFactures(row.mouvementsClients) }}
    </template>
    <template #dateFacture="{ row }">
      {{ getDateFacture(row.mouvementsClients) }}
    </template>
    <template #payeur="{ row }">
      <div
        :class="{ 'textDecorationLineThrough': !row.actif }"
        class="is-flex is-justify-content-space-between">
        {{ row.payeur.nomCommercial }}
      </div>
    </template>
    <template #annonceur="{ row }">
      <div :class="{ 'textDecorationLineThrough': !row.actif }">
        {{ getAnnonceurs(row) }}
      </div>
    </template>
    <template #destinataire="{ row }">
      <qd-taginput
        v-model="row.mail.to"
        @typing="e => onTyping(e, row)"
        @input="v => onChange(v, row)"
        @add="addContact($event, row)"
        @remove="removeContact(row.mail.to, row)"
        :data="row.filteredContacts"
        group-field="nomCommercial"
        group-options="contacts"
        field="nomToDisplay"
        type="is-primary"
        expanded
        allow-new
        autocomplete
        open-on-focus>
      </qd-taginput>
    </template>
  </v-client-table>
</template>

<script>
import uniq from 'lodash/uniq';
import cloneDeep from 'lodash/cloneDeep';
import {
  RESULTS_PER_PAGE_500,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { ETAT_RELANCES } from '@/configuration/relances/relancesConf';
import formatDate from '@/services/general/formatDate';
import { getFilteredContacts } from '@/services/relances/genererMailRelance';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formatDate,
    };
  },
  computed: {
    columnsData() {
      return [
        { name: 'relanceLibelle' },
        { name: 'date' },
        { name: 'etat' },
        { name: 'numFacture' },
        { name: 'dateFacture' },
        { name: 'payeur' },
        { name: 'annonceur' },
        { name: 'destinataire' },
      ];
    },
    columns() {
      return this.columnsData.map(c => c.name);
    },
    options() {
      const headings = this.columnsData.reduce((acc, val) => {
        acc[val.name] = !val.noTranslate ? this.$t(`relance.envoiMailMasse.steps.selection.tab.${val.name}`) : '';
        return acc;
      }, {});
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE_500,
        texts: texts,
        sortable: [],
        columnsClasses: {
          destinataire: 'is-min-width-500',
        },
      };
    },
  },
  methods: {
    getEtat(etatRelance) {
      const etat = ETAT_RELANCES.find((el) => etatRelance === el.etat);
      return etat.libelle;
    },
    getCodesFactures(mouvementClients) {
      const codes = [...new Set(mouvementClients.map(mvt => mvt.facture.code))];
      return codes.length > 1 ? this.$t('relance.envoiMailMasse.multiple') : codes[0];
    },
    getDateFacture(mouvementClients) {
      const dates = mouvementClients.map(mvt => formatDate(mvt.facture.date));
      return dates.length > 1 ? this.$t('relance.envoiMailMasse.multiple') : dates[0];
    },
    getAnnonceurs(relance) {
      return uniq(relance.mouvementsClients.flatMap(m => m.facture.annonceurs)).join(', ');
    },
    onChange(values, row) {
      const item = this.items.find(i => i.id === row.id);
      this.$set(item.mail, 'to', values);
      this.$set(item, 'filteredContacts', getFilteredContacts(row));
    },
    onTyping(text, row) {
      const item = this.items.find(i => i.id === row.id);
      this.$set(item, 'filteredContacts', getFilteredContacts(row, text));
    },
    addContact(contact, row) {
      if (row.destinataire) return;
      const item = this.items.find(i => i.id === row.id);
      const condition = typeof contact === 'object' && contact !== null;
      const destinataire = condition ? contact : {
        email: contact,
        nom: '',
        prenom: '',
      };
      this.$set(item, 'destinataire', destinataire);
    },
    removeContact(contacts, row) {
      const item = this.items.find(i => i.id === row.id);
      if (!contacts?.length) {
        this.$set(item, 'destinataire', null);
        return;
      }
      const contact = contacts[0];
      const condition = typeof contact === 'object' && contact !== null;
      const destinataire = condition ? contact : {
        email: contact,
        nom: '',
        prenom: '',
      };
      this.$set(item, 'destinataire', destinataire);
    },
  },
};
</script>
